import React, { useState, useContext, memo, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Accordion,
  useAccordionButton,
  AccordionContext,
} from "react-bootstrap";
import { RiDashboard3Line } from "react-icons/ri";
import {
  FaBan,
  FaFontAwesomeFlag,
  FaQuestion,
  FaTrashAlt,
  FaUsers,
} from "react-icons/fa";
import { BookFilled, DeleteFilled, HomeFilled } from "@ant-design/icons";
import { TbMessageReport } from "react-icons/tb";
import { VscUnverified } from "react-icons/vsc";
import { MdWorkspacePremium } from "react-icons/md";
import { ImDrawer } from "react-icons/im";
import { PiGraduationCapDuotone } from "react-icons/pi";
import { FaFaceSmileBeam } from "react-icons/fa6";
import { IoMusicalNotesSharp } from "react-icons/io5";
import { GrTemplate } from "react-icons/gr";


function CustomToggle({ children, eventKey, onClick }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, (active) =>
    onClick({ state: !active, eventKey: eventKey })
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <Link
      to="#"
      aria-expanded={isCurrentEventKey ? "true" : "false"}
      className="nav-link"
      role="button"
      onClick={(e) => {
        decoratedOnClick(isCurrentEventKey);
      }}
    >
      {children}
    </Link>
  );
}

const VerticalNav = memo((props) => {
  const [activeMenu, setActiveMenu] = useState(false);
  const [active, setActive] = useState("");
  //location

  const token = localStorage.getItem("token");
  let userPermission = [];

  if (token) {
    try {
      const userData = JSON.parse(atob(token.split(".")[1]));
      userPermission = userData.privelege || [];
    } catch (error) {
      console.error("Invalid token format", error);
      localStorage.removeItem("token"); // Optionally remove the invalid token
    }
  } else {
    // console.warn("No token found");
  }

  let location = useLocation();
  return (
    <Fragment>
      <Accordion as="ul" className="navbar-nav iq-main-menu">
        <li className="nav-item static-item">
          <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
            <span className="default-icon">Home</span>
            <span className="mini-icon">
              <HomeFilled />
            </span>
          </Link>
        </li>
        <li
          className={`${
            location.pathname === "/dashboard" ? "active" : ""
          } nav-item `}
        >
          <Link
            className={`${
              location.pathname === "/dashboard" ? "active" : ""
            } nav-link `}
            aria-current="page"
            to="/dashboard"
            onClick={() => {}}
          >
            <i className="icon">
              <RiDashboard3Line size={23} />
            </i>
            <span className="item-name">Statistics</span>
          </Link>
        </li>
        <li
          className={`${
            location.pathname === "/userList" ? "active" : ""
          } nav-item `}
        >
          <Link
            className={`${
              location.pathname === "/userList" ? "active" : ""
            } nav-link `}
            aria-current="page"
            to="/userList"
            onClick={() => {}}
          >
            <i className="icon">
              <FaUsers size={23} />
            </i>
            <span className="item-name">User List</span>
          </Link>
        </li>
        <li
          className={`${
            location.pathname === "/reportedUsers" ? "active" : ""
          } nav-item `}
        >
          <Link
            className={`${
              location.pathname === "/reportedUsers" ? "active" : ""
            } nav-link `}
            aria-current="page"
            to="/reportedUsers"
            onClick={() => {}}
          >
            <i className="icon">
              <TbMessageReport size={23} />
            </i>
            <span className="item-name">Reported Users</span>
          </Link>
        </li>
        <li
          className={`${
            location.pathname === "/deletedAccounts" ? "active" : ""
          } nav-item `}
        >
          <Link
            className={`${
              location.pathname === "/deletedAccounts" ? "active" : ""
            } nav-link `}
            aria-current="page"
            to="/deletedAccounts"
            onClick={() => {}}
          >
            <i className="icon">
              <FaTrashAlt size={23} />
            </i>
            <span className="item-name">Deleted Users</span>
          </Link>
        </li>
        {userPermission.includes("verification") && (
          <li
            className={`${
              location.pathname === "/underVerification" ? "active" : ""
            } nav-item `}
          >
            <Link
              className={`${
                location.pathname === "/underVerification" ? "active" : ""
              } nav-link `}
              aria-current="page"
              to="/underVerification"
              onClick={() => {}}
            >
              <i className="icon">
                <VscUnverified size={23} />
              </i>
              <span className="item-name">Under Verify Users</span>
            </Link>
          </li>
        )}
        {userPermission.includes("suspend") && (
          <li
            className={`${
              location.pathname === "/suspendedList" ? "active" : ""
            } nav-item `}
          >
            <Link
              className={`${
                location.pathname === "/suspendedList" ? "active" : ""
              } nav-link `}
              aria-current="page"
              to="/suspendedList"
              onClick={() => {}}
            >
              <i className="icon">
                <FaBan size={23} />
              </i>
              <span className="item-name">Suspended Accounts</span>
            </Link>
          </li>
        )}
        {(userPermission.includes("create") ||
          userPermission.includes("edit") ||
          userPermission.includes("delete")) && (
          <li
            className={`${
              location.pathname === "/faq" ? "active" : ""
            } nav-item `}
          >
            <Link
              className={`${
                location.pathname === "/faq" ? "active" : ""
              } nav-link `}
              aria-current="page"
              to="/faq"
              onClick={() => {}}
            >
              <i className="icon">
                <FaQuestion size={23} />
              </i>
              <span className="item-name">FAQ</span>
            </Link>
          </li>
        )}
        {(userPermission.includes("create") ||
          userPermission.includes("edit") ||
          userPermission.includes("delete")) && (
          <>
            <li>
              <hr className="hr-horizontal" />
            </li>
            <li className="nav-item static-item">
              <Link
                className="nav-link static-item disabled"
                to="#"
                tabIndex="-1"
              >
                <span className="default-icon">BOTTOM SHEET</span>
                <span className="mini-icon">-</span>
              </Link>
            </li>
            <Accordion.Item
              as="li"
              eventKey="sidebar-data"
              bsPrefix={`nav-item ${active === "data" ? "active" : ""} `}
              onClick={() => setActive("plan")}
            >
              <CustomToggle
                eventKey="sidebar-data"
                onClick={(activeKey) => setActiveMenu(activeKey)}
              >
                <i className="icon">
                  <ImDrawer />
                </i>
                <span className="item-name">Bottom Sheet Datas</span>
                <i className="right-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
              <Accordion.Collapse eventKey="sidebar-data">
                {(userPermission.includes("create") ||
                  userPermission.includes("edit") ||
                  userPermission.includes("delete")) && (
                  <ul className="sub-nav">
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/addData" ? "active" : ""
                        } nav-link`}
                        to="/addData"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> AD </i>
                        <span className="item-name">Add Data</span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/viewData" ? "active" : ""
                        } nav-link`}
                        to="/viewData"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> VD </i>
                        <span className="item-name">View Data</span>
                      </Link>
                    </li>
                  </ul>
                )}
              </Accordion.Collapse>
            </Accordion.Item>
            <Accordion.Item
              as="li"
              eventKey="sidebar-country"
              bsPrefix={`nav-item ${active === "country" ? "active" : ""} `}
              onClick={() => setActive("country")}
            >
              <CustomToggle
                eventKey="sidebar-country"
                onClick={(activeKey) => setActiveMenu(activeKey)}
              >
                <i className="icon">
                  <FaFontAwesomeFlag />
                </i>
                <span className="item-name">Country</span>
                <i className="right-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
              <Accordion.Collapse eventKey="sidebar-country">
                <ul className="sub-nav">
                  {userPermission.includes("create") && (
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/addCountry" ? "active" : ""
                        } nav-link`}
                        to="/addCountry"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> AC </i>
                        <span className="item-name">Add Country Data</span>
                      </Link>
                    </li>
                  )}
                  {(userPermission.includes("edit") ||
                    userPermission.includes("delete")) && (
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/viewCountry" ? "active" : ""
                        } nav-link`}
                        to="/viewCountry"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> VC </i>
                        <span className="item-name">View Country Data</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </Accordion.Collapse>
            </Accordion.Item>
            <Accordion.Item
              as="li"
              eventKey="sidebar-educ"
              bsPrefix={`nav-item ${active === "educ" ? "active" : ""} `}
              onClick={() => setActive("educ")}
            >
              <CustomToggle
                eventKey="sidebar-educ"
                onClick={(activeKey) => setActiveMenu(activeKey)}
              >
                <i className="icon">
                  <PiGraduationCapDuotone />
                </i>
                <span className="item-name">Education</span>
                <i className="right-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
              <Accordion.Collapse eventKey="sidebar-educ">
                <ul className="sub-nav">
                  {userPermission.includes("create") && (
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/addEducation" ? "active" : ""
                        } nav-link`}
                        to="/addEducation"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> AE </i>
                        <span className="item-name">Add Education</span>
                      </Link>
                    </li>
                  )}
                  {(userPermission.includes("edit") ||
                    userPermission.includes("delete")) && (
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/viewEducation" ? "active" : ""
                        } nav-link`}
                        to="/viewEducation"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> VE </i>
                        <span className="item-name">View Education</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </Accordion.Collapse>
            </Accordion.Item>
            {(userPermission.includes("create") ||
              userPermission.includes("edit") ||
              userPermission.includes("delete")) && (
              <li
                className={`${
                  location.pathname === "/hobby" ? "active" : ""
                } nav-item `}
              >
                <Link
                  className={`${
                    location.pathname === "/hobby" ? "active" : ""
                  } nav-link `}
                  aria-current="page"
                  to="/hobby"
                  onClick={() => {}}
                >
                  <i className="icon">
                    <FaFaceSmileBeam size={23} />
                  </i>
                  <span className="item-name">Hobby</span>
                </Link>
              </li>
            )}
          </>
        )}
        {userPermission.includes("subscription") && (
          <>
            <li>
              <hr className="hr-horizontal" />
            </li>
            <li className="nav-item static-item">
              <Link
                className="nav-link static-item disabled"
                to="#"
                tabIndex="-1"
              >
                <span className="default-icon">SUBSCRIPTION</span>
                <span className="mini-icon">-</span>
              </Link>
            </li>
            <Accordion.Item
              as="li"
              eventKey="sidebar-plan"
              bsPrefix={`nav-item ${active === "plan" ? "active" : ""} `}
              onClick={() => setActive("plan")}
            >
              <CustomToggle
                eventKey="sidebar-plan"
                onClick={(activeKey) => setActiveMenu(activeKey)}
              >
                <i className="icon">
                  <MdWorkspacePremium />
                </i>
                <span className="item-name">Plans</span>
                <i className="right-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
              <Accordion.Collapse eventKey="sidebar-plan">
                <ul className="sub-nav">
                  <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === "/viewPlans" ? "active" : ""
                      } nav-link`}
                      to="/viewPlans"
                    >
                      <i className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <g>
                            <circle
                              cx="12"
                              cy="12"
                              r="8"
                              fill="currentColor"
                            ></circle>
                          </g>
                        </svg>
                      </i>
                      <i className="sidenav-mini-icon"> VP </i>
                      <span className="item-name">View Plans</span>
                    </Link>
                  </li>
                </ul>
              </Accordion.Collapse>
            </Accordion.Item>
            <Accordion.Item
              as="li"
              eventKey="sidebar-subuser"
              bsPrefix={`nav-item ${active === "subuser" ? "active" : ""} `}
              onClick={() => setActive("subuser")}
            >
              <CustomToggle
                eventKey="sidebar-subuser"
                onClick={(activeKey) => setActiveMenu(activeKey)}
              >
                <i className="icon">
                  <FaUsers />
                </i>
                <span className="item-name">Manage Users</span>
                <i className="right-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
              <Accordion.Collapse eventKey="sidebar-subuser">
                <ul className="sub-nav">
                  {/* <li className="nav-item">
                                <Link className={`${location.pathname === '/addSubscription' ? 'active' : ''} nav-link`} to="/addSubscription">
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                            <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <i className="sidenav-mini-icon"> AS </i>
                                    <span className="item-name">Add Subscription</span>
                                </Link>
                            </li> */}
                  <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === "/subscribers" ? "active" : ""
                      } nav-link`}
                      to="/subscribers"
                    >
                      <i className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <g>
                            <circle
                              cx="12"
                              cy="12"
                              r="8"
                              fill="currentColor"
                            ></circle>
                          </g>
                        </svg>
                      </i>
                      <i className="sidenav-mini-icon"> VS </i>
                      <span className="item-name">View Subscribers</span>
                    </Link>
                  </li>
                </ul>
              </Accordion.Collapse>
            </Accordion.Item>
          </>
        )}
        {(userPermission.includes("create") ||
          userPermission.includes("edit") ||
          userPermission.includes("delete")) && (
          <>
            <li>
              <hr className="hr-horizontal" />
            </li>
            <li className="nav-item static-item">
              <Link
                className="nav-link static-item disabled"
                to="#"
                tabIndex="-1"
              >
                <span className="default-icon">Audio and reels</span>
                <span className="mini-icon">-</span>
              </Link>
            </li>
            <Accordion.Item
              as="li"
              eventKey="sidebar-audio"
              bsPrefix={`nav-item ${active === "audio" ? "active" : ""} `}
              onClick={() => setActive("audio")}
            >
              <CustomToggle
                eventKey="sidebar-audio"
                onClick={(activeKey) => setActiveMenu(activeKey)}
              >
                <i className="icon">
                  <IoMusicalNotesSharp />
                </i>
                <span className="item-name">Audio</span>
                <i className="right-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
              <Accordion.Collapse eventKey="sidebar-audio">
                {(userPermission.includes("create") ||
                  userPermission.includes("edit") ||
                  userPermission.includes("delete")) && (
                  <ul className="sub-nav">
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/add-audio" ? "active" : ""
                        } nav-link`}
                        to="/add-audio"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> AA </i>
                        <span className="item-name">Add audio</span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/view-audio" ? "active" : ""
                        } nav-link`}
                        to="/view-audio"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> VA </i>
                        <span className="item-name">View Audios</span>
                      </Link>
                    </li>
                  </ul>
                )}
              </Accordion.Collapse>
            </Accordion.Item>
            <Accordion.Item
              as="li"
              eventKey="sidebar-template"
              bsPrefix={`nav-item ${active === "template" ? "active" : ""} `}
              onClick={() => setActive("template")}
            >
              <CustomToggle
                eventKey="sidebar-template"
                onClick={(activeKey) => setActiveMenu(activeKey)}
              >
                <i className="icon">
                  <GrTemplate />
                </i>
                <span className="item-name">Templates</span>
                <i className="right-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
              <Accordion.Collapse eventKey="sidebar-template">
                <ul className="sub-nav">
                  {/* {userPermission.includes("create") && (
                                <li className="nav-item">
                                <Link className={`${location.pathname === '/add-template' ? 'active' : ''} nav-link`} to="/add-template">
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                            <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <i className="sidenav-mini-icon"> AC </i>
                                    <span className="item-name">Add Templates</span>
                                </Link>
                            </li>
                            ) } */}
                  {(userPermission.includes("edit") ||
                    userPermission.includes("delete")) && (
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/view-template" ? "active" : ""
                        } nav-link`}
                        to="/view-template"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> VC </i>
                        <span className="item-name">View Templates</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </Accordion.Collapse>
            </Accordion.Item>
            <Accordion.Item
              as="li"
              eventKey="sidebar-reels"
              bsPrefix={`nav-item ${active === "reels" ? "active" : ""} `}
              onClick={() => setActive("reels")}
            >
              <CustomToggle
                eventKey="sidebar-reels"
                onClick={(activeKey) => setActiveMenu(activeKey)}
              >
                <i className="icon">
                  <GrTemplate />
                </i>
                <span className="item-name">Reels</span>
                <i className="right-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>
              <Accordion.Collapse eventKey="sidebar-reels">
                <ul className="sub-nav">
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === "/reels" ? "active" : ""
                        } nav-link`}
                        to="/reels"
                      >
                        <i className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <g>
                              <circle
                                cx="12"
                                cy="12"
                                r="8"
                                fill="currentColor"
                              ></circle>
                            </g>
                          </svg>
                        </i>
                        <i className="sidenav-mini-icon"> UR </i>
                        <span className="item-name">Uploaded Reels</span>
                      </Link>
                    </li>
                </ul>
              </Accordion.Collapse>
            </Accordion.Item>
          </>
        )}
        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item static-item">
          <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
            <span className="default-icon">USER</span>
            <span className="mini-icon">-</span>
          </Link>
        </li>
        <Accordion.Item
          as="li"
          eventKey="sidebar-user"
          bsPrefix={`nav-item ${active === "user" ? "active" : ""} `}
          onClick={() => setActive("user")}
        >
          <CustomToggle
            eventKey="sidebar-user"
            onClick={(activeKey) => setActiveMenu(activeKey)}
          >
            <i className="icon">
              <svg
                width="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z"
                  fill="currentColor"
                ></path>
                <path
                  opacity="0.4"
                  d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z"
                  fill="currentColor"
                ></path>
                <path
                  opacity="0.4"
                  d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z"
                  fill="currentColor"
                ></path>
                <path
                  opacity="0.4"
                  d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z"
                  fill="currentColor"
                ></path>
              </svg>
            </i>
            <span className="item-name">Admin</span>
            <i className="right-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </i>
          </CustomToggle>
          <Accordion.Collapse eventKey="sidebar-user">
            <ul className="sub-nav">
              <li className="nav-item">
                <Link
                  className={`${
                    location.pathname === "/viewAdmin" ? "active" : ""
                  } nav-link`}
                  to="/viewAdmin"
                >
                  <i className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <g>
                        <circle
                          cx="12"
                          cy="12"
                          r="8"
                          fill="currentColor"
                        ></circle>
                      </g>
                    </svg>
                  </i>
                  <i className="sidenav-mini-icon"> AP </i>
                  <span className="item-name">Admin Profile</span>
                </Link>
              </li>
              {userPermission.includes("create") && (
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === "/createAdmin" ? "active" : ""
                    } nav-link`}
                    to="/createAdmin"
                  >
                    <i className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <g>
                          <circle
                            cx="12"
                            cy="12"
                            r="8"
                            fill="currentColor"
                          ></circle>
                        </g>
                      </svg>
                    </i>
                    <i className="sidenav-mini-icon"> AU </i>
                    <span className="item-name">Add User / Admin</span>
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link
                  className={`${
                    location.pathname === "/adminList" ? "active" : ""
                  } nav-link`}
                  to="/adminList"
                >
                  <i className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <g>
                        <circle
                          cx="12"
                          cy="12"
                          r="8"
                          fill="currentColor"
                        ></circle>
                      </g>
                    </svg>
                  </i>
                  <i className="sidenav-mini-icon"> UL </i>
                  <span className="item-name">Admin / User List</span>
                </Link>
              </li>
            </ul>
          </Accordion.Collapse>
        </Accordion.Item>
        <li>
          <hr className="hr-horizontal" />
        </li>
      </Accordion>
    </Fragment>
  );
});

export default VerticalNav;
